import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PendingService {
  private entityListDisabled: any;
  constructor() { }

  setEntityListDisabled(dt) {
    this.entityListDisabled = dt;
  }

  getEntityListDisabled() {
    return this.entityListDisabled;
  }
}
